import React, { useEffect, useRef, useState } from "react";
import { useVoice } from "../../contexts/VoiceContext";

const CallOverlay = () => {
  const { status, endCall, activeCall, currentNumber, error } = useVoice();
  const prevStatusRef = useRef(status);
  const toastTimerRef = useRef(null);
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    const prev = prevStatusRef.current;
    if (prev === status) return;

    if (toastTimerRef.current) {
      clearTimeout(toastTimerRef.current);
      toastTimerRef.current = null;
    }

    const show = (msg) => {
      setToastMessage(msg);
      setShowToast(true);
      toastTimerRef.current = setTimeout(() => {
        setShowToast(false);
      }, 2000);
    };

    if (status === "error") show(`Voice error: ${error?.message || "Unknown error"}`);

    if (
      status === "ready" &&
      (prev === "calling" || prev === "ringing" || prev === "dialing")
    ) {
      show("Call ended");
    }

    prevStatusRef.current = status;
  }, [status, error]);

  useEffect(() => {
    return () => {
      if (toastTimerRef.current) clearTimeout(toastTimerRef.current);
    };
  }, []);

  const showOverlay = status === "calling" || status === "dialing" || status === "ringing";
  if (!showOverlay && !showToast) return null;

  const isDialing = status === "dialing";
  const isRinging = status === "ringing";

  let statusText = "In Call";
  if (isDialing) statusText = "Dialing...";
  if (isRinging) statusText = "Ringing...";

  return (
    <>
      {showToast && (
        <div className="fixed bottom-4 right-4 z-[9999] bg-red-50 text-white px-3 py-2 rounded shadow-lg">
          {toastMessage}
        </div>
      )}

      {showOverlay && (
        <div className="fixed bottom-4 right-4 z-50 w-72 bg-white rounded-lg shadow-xl border border-gray-200 overflow-hidden">
          <div className="bg-primary text-white p-3 flex justify-between items-center">
            <span className="font-semibold px-2">{statusText}</span>
            <div className="flex gap-2">
              <div
                className={`w-3 h-3 rounded-full mr-2 ${
                  isDialing || isRinging ? "bg-yellow-400 animate-pulse" : "bg-green-400"
                }`}
              ></div>
            </div>
          </div>

          <div className="p-4 flex flex-col items-center">
            <div className="mb-4 text-center text-gray-800 font-medium">
              {currentNumber || activeCall?.parameters?.To || "Unknown Number"}
            </div>

            <div className="flex gap-4">
              <button
                onClick={endCall}
                className="bg-red-500 hover:bg-red-600 text-white rounded-full w-12 h-12 flex items-center justify-center shadow-md transition-colors"
                title="End Call"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CallOverlay;
